module.exports = {"411424001":"长江新城街道","411424002":"浦东街道","411424100":"柘城县城关镇","411424101":"陈青集镇","411424102":"起台镇","411424103":"胡襄镇","411424104":"慈圣镇","411424105":"安平镇","411424106":"远襄镇","411424107":"岗王镇","411424108":"伯岗镇","411424109":"张桥镇","411424200":"邵元乡","411424203":"洪恩乡","411424204":"老王集乡","411424205":"大仵乡","411424206":"马集乡","411424207":"牛城乡","411424208":"惠济乡","411424212":"申桥乡","411424213":"李原乡","411424214":"皇集乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411424.json
// module id = 1658
// module chunks = 0